import React, { useContext, useState } from 'react'


import { Context } from '../../../context/app-context'
import ReactPlayer from 'react-player/youtube'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import Button from '../../atoms/button/button'
import './game-video-modal.scss'
import { preGameUrlVideos } from '../../../constants/activity-constants'
import MessageWinPoints from '../../atoms/message-win-points/message-win-points'
import { useRef } from 'react'
import Show from '../../../utils/show'


const LOCALE = process.env.LOCALE;
const italatam = LOCALE === 'es-AR';

const GameVideoModal = ({ pointsToWin = 1, onSkipVideo, onFinishVideo }) => {
  const vidplayer = useRef();
  const [played, setPLayed] = useState(0);
  const [maxSeconds, setMaxSeconds] = useState(0);
  const [watched, setWatched] = useState(false);
  const { dispatch } = useContext(Context);
  const VIDEO_URL = preGameUrlVideos.video[0];
  const playIcon = <div className='f-game-video-modal__playvideobutton' />

  const onClickPreviewHandler = () => {
    pushEventData({
      event: 'Video',
      action: 'click video',
      label: 'imagen'
    })
    // WAIT ... hammer time
    setTimeout(() => {
      // FIND THE YOUTUBE API
      const tag = document.querySelector("script[src='https://www.youtube.com/iframe_api']")
      //  console.log("ON CLICK PREVIEW IS RUNNING1", tag);
      const parent = tag.parentElement;
      // remove
      tag.remove();
      // change type
      tag.type = "text/javascript";// text/plain
      // append again
      parent.appendChild(tag);
      //
    }, 10);
  }

  const handleFinishVideo = () => {

    setWatched(true);

    setTimeout(() => {
      videoTimeDataLayer(played)
      onFinishVideo(pointsToWin);
      dispatch({
        type: 'clear-modal'
      })
    }, 3000);
  }

  const handleSkipVideo = () => {
    videoTimeDataLayer(played)
    onSkipVideo()
    dispatch({
      type: 'clear-modal'
    })
  }

  const startdataLayer = () => {

    pushEventData({
      event: 'Video',
      action: 'click video',
      label: 'video',
      duration_video: `0s`
    })
  }
  const videoTimeDataLayer = seconds => {
    pushEventData({
      event: 'Video',
      action: 'click video',
      label: 'video',
      duration_video: `${seconds}s`
    })

  }

  const onProgressHandler = (progress) => {

    // -- console.log("time-spent on video", progress, vidplayer.current)
    setMaxSeconds(vidplayer.current.getDuration());
    setPLayed(progress.playedSeconds)
  };

  const formatMinute = (time) => {
    var minutes = Math.floor(time / 60).toFixed(0);
    var seconds = (time - minutes * 60).toFixed(0);
    return minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");
  };



  return (
    <div className="f-game-video-modal">

      <div className="f-game-video-modal__top-container">
        <Show valid={!watched}>
          <MessageWinPoints className='f-game-video-modal__message' icon="video"
            text1={<>¡Dale play al video y {italatam ? 'ganá' : 'gana'} {pointsToWin} puntos adicionales!</>} />
          <Button
            className="f-game-video-modal__skip-button --right"
            onClick={handleSkipVideo}>
            SKIP
          </Button>
        </Show>
        <Show valid={watched}>
          <MessageWinPoints className='--animate__zoomInUp' text1='Ganaste ' text2={(pointsToWin + " puntos")} />
        </Show>
      </div>


      <div className="f-game-video-modal__container__video">
        <ReactPlayer
          ref={vidplayer}
          url={VIDEO_URL}//'https://www.youtube.com/watch?v=dT4c-a6jToE&ab_channel=Nosotras'
          width="100%"
          height="100%"
          light={true}
          className="f-game-video-modal__container__video__frame"
          controls={false}
          playIcon={playIcon}
          volume={.9}
          playing={true}
          onClickPreview={onClickPreviewHandler}
          onEnded={handleFinishVideo}
          onPlay={startdataLayer}
          onProgress={onProgressHandler}
        />

        <div className='f-game-video-modal__controls'>
          <div className='f-game-video-modal__progress'>
            <div className='f-game-video-modal__progress__bar' style={{ width: ((played / maxSeconds) * 100 + 1) + "%" }} />
          </div>
          <div className='f-game-video-modal__timelapse-text'>
            {formatMinute(played)} / {formatMinute(maxSeconds)}
          </div>
        </div>

      </div>


    </div>
  )
}

export default GameVideoModal
